import React, {FC} from 'react'
import Stars from './Stars'
import {cn} from '@/lib/utils'
import useResponsiveWidth from '@/hooks/useResponsiveWidth'

interface RatingPropTypes {
    rating: number
    reviewCount?: number
    siteId: string
    size?: 'small' | 'medium' | 'large'
}

const Ratings: FC<RatingPropTypes> = ({rating, reviewCount, siteId, size = 'small'}) => {
    const {isCompact, elementRef} = useResponsiveWidth(180)
    const filledStars = Math.floor(rating)
    const remainder = rating - filledStars

    return (
        <div
            ref={elementRef}
            className={cn('w-full flex flex-row items-center', {
                ['items-center']: isCompact
            })}
        >
            <div className="flex ">
                <Stars
                    filledStars={filledStars}
                    remainder={remainder}
                    siteId={siteId}
                    size={size}
                    data-testid="Ratings-Stars"
                />
            </div>
            <label
                className={cn('ml-0 mt-[.2rem]  flex sm:text-sm xs:text-[.7rem] xs:ml-[.2rem]', {
                    'text-sm': size === 'small',
                    'ml-[.2rem]': size === 'small' && !isCompact,
                    'ml-[.5rem]': size === 'large' && !isCompact
                })}
            >
                {reviewCount ? reviewCount : '0'} Reviews
            </label>
        </div>
    )
}

export default Ratings
